import PostControls from '../utils/PostControls';
import AbstractPost from './AbstractPost';
/**
 * The `Post` component displays a single post. The basic post template just
 * includes a controls dropdown; subclasses must implement `content` and `attrs`
 * methods.
 */
export default class Post extends AbstractPost {
  oninit(vnode) {
    super.oninit(vnode);
  }
  user() {
    return this.attrs.post.user();
  }
  controls() {
    return PostControls.controls(this.attrs.post, this).toArray();
  }
  freshness() {
    return this.attrs.post.freshness;
  }
  createdByStarter() {
    const user = this.attrs.post.user();
    const discussion = this.attrs.post.discussion();
    return user && user === discussion.user();
  }
  onbeforeupdate(vnode) {
    return super.onbeforeupdate(vnode);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
  }

  /**
   * Get attributes for the post element.
   */
  elementAttrs() {
    return super.elementAttrs();
  }
  header() {
    return super.header();
  }

  /**
   * Get the post's content.
   */
  content() {
    return super.content();
  }

  /**
   * Get the post's classes.
   */
  classes(existing) {
    let classes = super.classes(existing);
    const user = this.attrs.post.user();
    const discussion = this.attrs.post.discussion();
    if (user && user === discussion.user()) {
      classes.push('Post--by-start-user');
    }
    return classes;
  }

  /**
   * Build an item list for the post's actions.
   */
  actionItems() {
    return super.actionItems();
  }

  /**
   * Build an item list for the post's footer.
   */
  footerItems() {
    return super.footerItems();
  }
  sideItems() {
    return super.sideItems();
  }
  avatar() {
    return super.avatar();
  }
}
flarum.reg.add('core', 'forum/components/Post', Post);